import { motion } from "framer-motion";
import { Sparkles, ArrowRight, Shield, Check, Zap, Clock } from "lucide-react";

export function FinalCTASection({ slotsData, onScrollToForm }) {
  return (
    <section className="py-24 sm:py-32 px-4 sm:px-6 lg:px-8 relative overflow-hidden bg-[#0a0a0a]" data-testid="final-cta-section">
      {/* Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#00FF66]/5 rounded-full blur-3xl" />

      <div className="relative z-10 max-w-4xl mx-auto text-center">
        {slotsData.remaining_slots > 0 && (
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="inline-flex items-center gap-2 bg-[#00FF66]/10 border border-[#00FF66]/30 text-[#00FF66] px-5 py-2 text-sm font-bold mb-8 font-['Outfit',sans-serif]"
          >
            <Clock className="w-4 h-4" />
            OFFRE LIMITÉE — {slotsData.remaining_slots} PLACE{slotsData.remaining_slots > 1 ? "S" : ""} RESTANTE{slotsData.remaining_slots > 1 ? "S" : ""}
          </motion.div>
        )}

        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="font-['Clash_Display',sans-serif] text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white uppercase"
          data-testid="final-cta-headline"
        >
          Vous avez un projet ?
          <br />
          <span className="text-[#00FF66]">On vous propose un devis gratuit</span>
        </motion.h2>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.15 }}
          className="mt-6 text-lg text-zinc-400 max-w-xl mx-auto font-['Outfit',sans-serif]"
        >
          Une étude claire, un prix juste, une réponse rapide.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.25 }}
        >
          <button
            onClick={onScrollToForm}
            className="mt-8 inline-flex items-center gap-2 bg-[#00FF66] text-black px-10 py-5 text-lg font-bold uppercase tracking-wider hover:shadow-[0_0_40px_rgba(0,255,102,0.4)] transition-all duration-300 font-['Outfit',sans-serif]"
            data-testid="final-cta-btn"
          >
            Demander un devis gratuit &gt;
          </button>
        </motion.div>

        <p className="mt-6 text-sm text-zinc-600 flex items-center justify-center gap-4 flex-wrap font-['Outfit',sans-serif]">
          <span className="flex items-center gap-1"><Shield className="w-4 h-4" /> Sans engagement</span>
          <span className="flex items-center gap-1"><Check className="w-4 h-4" /> Projet personnalisé</span>
          <span className="flex items-center gap-1"><Zap className="w-4 h-4" /> Réponse sous 24h</span>
        </p>
      </div>
    </section>
  );
}
